// test1682
(1682 && 0);
